import { render, staticRenderFns } from "./myjl.vue?vue&type=template&id=3a23d3a4&scoped=true"
import script from "./myjl.vue?vue&type=script&lang=js"
export * from "./myjl.vue?vue&type=script&lang=js"
import style0 from "./myjl.vue?vue&type=style&index=0&id=3a23d3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23d3a4",
  null
  
)

export default component.exports